module.exports = __webpack_public_path__ + "img/index-kinds-service.3a7d9878.png";